import { gql, useQuery } from "@apollo/client";
import { OPTUM_FRONTIER_THERAPIES } from "shared/src/data/providerNames";

const GET_PROVIDER_FOR_SUCRAID = gql(`
  query GetProviderForSucraid {
    provider {
      providerId
      providerName
    }
  }
`);

export function useAllowSucraid(): boolean {
  const { loading, data, error } = useQuery(GET_PROVIDER_FOR_SUCRAID, {
    fetchPolicy: "no-cache",
  });

  if (loading || error || !data?.provider) {
    return false;
  }

  return data.provider.providerName.includes(OPTUM_FRONTIER_THERAPIES);
}
